import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { fieldValueToString } from "../utils/react_hook_form_input_utils";



/**
 * DefaultSelectInputOption
 */

export type DefaultSelectInputOption = { id: number, label: string } | { id: string, label: string };

/**
 * DefaultSelectInput
 */

type Props = {
  name: string,
  label: string,
  required?: boolean,
  options: DefaultSelectInputOption[],
  initialOptionId?: number | string,
  initialOptionLabel?: string,
  showSelectionLabel?: boolean,
  value?: number | string | null,
  helperText?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onChangeValue?: (newValue: string) => void;
};

export const DefaultSelectInput = ({
  name,
  label,
  required,
  options,
  initialOptionId = '',
  initialOptionLabel = 'Selecionar',
  showSelectionLabel = true,
  value,
  helperText,
  disabled,
  readOnly,
  onChangeValue,
}: Props) => {
  return (
    <FormControl
      size="small"
      fullWidth={true}
      required={required}>
      <InputLabel
        id={`select-${name as string}`}
        size="small"
        error={helperText !== null && helperText !== undefined}
        required={required}>
        {label}
      </InputLabel>

      <Select
        size="small"
        labelId={`select-${name as string}`}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        value={fieldValueToString(value) ?? ''}
        onChange={e => {
          if (typeof e.target.value === 'string') {
            onChangeValue?.(e.target.value);
          }
          else if (typeof e.target.value === 'number') {
            const v = e.target.value as number;
            onChangeValue?.(v.toString());
          }
          else {
            onChangeValue?.('');
          }
        }}>
        {showSelectionLabel && <MenuItem value={initialOptionId}>{initialOptionLabel}</MenuItem>}
        {options.map(x => <MenuItem key={x.id} value={x.id}>{x.label}</MenuItem>)}
      </Select>

      <FormHelperText id={`select-${name as string}`} error={true}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}